import React from 'react';
import ToastBase from './ToastBase';

import TToast from './@types/TToast';
import TEFeedbackSignal from '../../types/TEFeedbackSignal';

const Success = ({ children, icon, ...rest }: TToast) => (
  <ToastBase signal={TEFeedbackSignal.Success} icon={icon} {...rest}>
    {children}
  </ToastBase>
);

export default Success;
